import appConfig from "@/app.config";

const schema = {
  tabs: [
    {
      title: 'News',
      meta: [{ name: "description", content: appConfig.description }],
      name: "News",
      activeBtn: true,
      addNewBtn: true,
      deleteBtn: true,
      addNewModalTitle: 'Add New Page',
      formData: {},
      schema: {
      name: {
        type: 'text',
        label: 'Page Title',
        placeholder: 'Enter Page Title',
        required: true,
        info: false,
        character_count: 50
        },
      },
      side_panel: {
        select_a_page: {
          type: 'list',
          label: 'Select News',
          placeholder: '',
          required: false,
          info: true,
          character_count: 0,
          disabled: false,
          wrapper_class: '',
          options: [],
          draggable: true
        }
      },
      form: {
        title: {
            type: 'text',
            label: 'News Title',
            placeholder: 'Enter News Title',
            required: true,
            info: true,
            character_count: 250,
            disabled: false,
            wrapper_class: ''
          },
        date: {
          type: 'date',
          label: 'Date',
          placeholder: 'Enter Date',
          required: true,
          info: true,
          character_count: 0,
          disabled: false,
          wrapper_class: 'col-6'
        },
        featured: {
          type: 'toggle',
          label: 'Featured',
          placeholder: 'Enter Featured',
          required: false,
          info: true,
          character_count: 0,
          disabled: false,
          wrapper_class: 'col-6'
        },
        path: {
            type: 'text',
            label: 'Path',
            placeholder: 'Enter Path',
            required: false,
            info: true,
            character_count: 50,
            disabled: false,
            wrapper_class: ''
        },
        upload_options: {
            type: 'select',
            label: 'Upload Options',
            placeholder: '',
            required: false,
            info: true,
            character_count: 0,
            disabled: false,
            wrapper_class: 'col-6',
            options: [
              // 'Image', 
              'Video']
        },
        // image_url: {
        //     type: 'file',
        //     label: 'Image',
        //     placeholder: 'Select Image',
        //     required: false,
        //     info: true,
        //     character_count: 0,
        //     disabled: false,
        //     wrapper_class: ''
        // },
        video_url: {
            type: 'text',
            label: 'Video URL',
            placeholder: 'Enter Video URL',
            required: false,
            info: true,
            character_count: 0,
            disabled: false,
            wrapper_class: 'col-6'
        },
        description: {
          type: 'ckeditor',
          label: 'Description',
          placeholder: 'Enter Description',
          required: true,
          info: false,
          character_count: 2000,
          disabled: false,
          wrapper_class: ''
        },
      }
    }
  ]
};

export { schema };